import { pad0 } from './number';
import { plural } from './plural';
// export const weekDays = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
// export const weekDaysAccusative = ['в воскресенье', 'в понедельник', 'во вторник', 'в среду', 'в четверг', 'в пятницу', 'в субботу'];
export const monthNamesGenitive = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
export const any2unixtime = (any) => {
    if (typeof any === 'object' && 'getMonth' in any) {
        return Math.floor(any.getTime() / 1e3);
    }
    if (typeof any === 'number' && any > 1e11) {
        return Math.floor(any / 1e3);
    }
    if (typeof any === 'number') {
        return any;
    }
    throw `Cannot convert ${any} (typeof=${typeof any}) to date!`;
};
export const unixtime2local = (time) => time - new Date(time * 1e3).getTimezoneOffset() * 60;
export const local2unixtime = (time) => time + new Date(time * 1e3).getTimezoneOffset() * 60;
export const dayStart = (dt) => {
    const t = dt != null ? new Date(dt) : new Date();
    t.setHours(0, 0, 0, 0);
    return t;
};
export const dayEnd = (dt) => {
    const t = dt != null ? new Date(dt) : new Date();
    t.setHours(23, 59, 59, 999);
    return t;
};
export const todayStart = () => dayStart(null);
export const todayEnd = () => dayEnd(null);
export const yesterdayStart = () => dayStart(new Date(Date.now() - 24 * 60 * 60e3));
export const yesterdayEnd = () => dayEnd(new Date(Date.now() - 24 * 60 * 60e3));
export const daysInPastFromNow = (dt, now = null) => Math.floor((dayEnd(now).getTime() - dt.getTime()) / (24 * 60 * 60 * 1000));
export const timeInPast_parts = (dt, options) => {
    let date;
    switch (daysInPastFromNow(dt, options?.now)) {
        case 0:
            date = 'сегодня';
            break;
        case 1:
            date = 'вчера';
            break;
        default: {
            if (dayEnd(options?.now ?? null).getFullYear() === dt.getFullYear())
                date = `${dt.getDate()} ${monthNamesGenitive[dt.getMonth()]}`;
            else
                date = rusDateOnly(dt);
        }
    }
    return {
        time: rusTimeOnly(dt, options?.withSeconds),
        date,
    };
};
export const timeInPast = (dt, options) => {
    const parts = timeInPast_parts(dt, options);
    return `${parts['time']} ${parts['date']}`;
};
export const dateTimeInPast = (dt, options) => {
    const parts = timeInPast_parts(dt, options);
    return `${parts['date']} ${parts['time']}`;
};
export const dateInPast = (dt, options) => {
    const parts = timeInPast_parts(dt, options);
    return parts['date'];
};
export const rangeInPastForStats = (d1, d2, now = null) => {
    const formatDateTime = (dt) => {
        switch (daysInPastFromNow(dt, now)) {
            case 0:
                return `сегодня ${rusTimeOnly(dt)}`;
            case 1:
                return `вчера ${rusTimeOnly(dt)}`;
            default:
                return `${dt.getDate()} ${monthNamesGenitive[dt.getMonth()]} ${rusTimeOnly(dt)}`;
        }
    };
    const part1 = formatDateTime(d1);
    const part2 = d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
        ? rusTimeOnly(d2)
        : formatDateTime(d2);
    return `${part1} — ${part2}`;
};
export const humanDateWithMonth = (d, nbsp = false, titlecase = false) => {
    let monthName = monthNamesGenitive[d.getMonth()];
    if (titlecase)
        monthName = monthName[0].toUpperCase() + monthName.slice(1);
    const space = nbsp ? '&nbsp;' : ' ';
    return d.getDate() + space + monthName;
};
const _intervalPlurals = {
    days: {
        nominative: ['сутки', 'суток', 'суток'],
        accusative: ['сутки', 'суток', 'суток'],
    },
    hours: {
        nominative: ['час', 'часа', 'часов'],
        accusative: ['час', 'часа', 'часов'],
    },
    minutes: {
        nominative: ['минута', 'минуты', 'минут'],
        accusative: ['минуту', 'минуты', 'минут'],
        short: 'мин',
    },
    seconds: {
        nominative: ['секунда', 'секунды', 'секунд'],
        accusative: ['секунду', 'секунды', 'секунд'],
        short: 'сек',
    },
};
export const prettyTimeInterval = (secs, options) => {
    secs = ~~secs;
    const nbsp = options?.nbsp ? '&nbsp;' : options?.nbsp_unicode ? '\u00a0' : ' ';
    const get_plurals = (segment) => {
        const spec = _intervalPlurals[segment];
        if (options?.short && spec.short != null)
            return [spec.short, spec.short, spec.short];
        return spec[options?.accusative ? 'accusative' : 'nominative'];
    };
    const plural2 = (num, forms) => plural(num, ...forms);
    const mins = Math.floor(secs / 60);
    const hours = Math.floor(mins / 60);
    const days = Math.floor(hours / 24);
    const parts = [
        [days, days + nbsp + plural2(days, get_plurals('days'))],
        [hours % 24, (hours % 24) + nbsp + plural2(hours % 24, get_plurals('hours'))],
        [mins % 60, (mins % 60) + nbsp + plural2(mins % 60, get_plurals('minutes'))],
    ];
    if (options?.seconds ?? true)
        parts.push([
            secs % 60,
            (secs % 60) + nbsp + plural2(secs % 60, get_plurals('seconds')),
        ]);
    let i = 0;
    for (const p of parts) {
        if (p[0] !== 0) {
            if (parts[i + 1]?.[0])
                return parts[i][1] + ' ' + parts[i + 1][1];
            return parts[i][1];
        }
        i++;
    }
    return parts[parts.length - 1][1];
};
export const duration = (secs, options) => {
    if (!options?.seconds)
        secs = Math.floor((secs + 59) / 60) * 60;
    const parts = [Math.floor(secs / 3600), Math.floor((secs % 3600) / 60)];
    if (options?.seconds)
        parts.push(Math.floor(secs % 60));
    if (parts[0] === 0 && !options?.zeros)
        parts.shift();
    return parts.map((part) => pad0(part, 2)).join(':');
};
export const durationWithLetters = (secs, options) => {
    const use_seconds = options?.seconds || (options?.fallback_to_seconds && secs < 60);
    if (!use_seconds)
        secs = ~~((secs + 59) / 60) * 60;
    const parts = [Math.floor(secs / 3600), Math.floor((secs % 3600) / 60)];
    const units = ['ч', 'м'];
    if (use_seconds) {
        parts.push(Math.floor(secs % 60));
        units.push('с');
    }
    if (!options?.zeros) {
        while (parts.length > 1 && parts[0] === 0) {
            parts.shift();
            units.shift();
        }
    }
    let str_parts;
    if (options?.pad2)
        str_parts = parts.map((p) => pad0(p, 2));
    else if (options?.pad2_except_first)
        str_parts = parts.map((p, i) => (i === 0 ? p.toString() : pad0(p, 2)));
    else
        str_parts = parts.map((n) => n.toString());
    const sep = options?.nbsp ? '&nbsp;' : ' ';
    return str_parts.map((_, i) => str_parts[i] + units[i]).join(sep);
};
export const rusDateOnly = (date) => `${pad0(date.getDate(), 2)}.${pad0(date.getMonth() + 1, 2)}.${date.getFullYear()}`;
export const rusTimeOnly = (date, withSeconds = false) => {
    const seconds = withSeconds ? `:${pad0(date.getSeconds(), 2)}` : '';
    return `${pad0(date.getHours(), 2)}:${pad0(date.getMinutes(), 2)}${seconds}`;
};
export const rusDateTime = (date, withSeconds = false) => `${rusDateOnly(date)} ${rusTimeOnly(date, withSeconds)}`;
export const rusTimeDate = (date, withSeconds = false) => `${rusTimeOnly(date, withSeconds)} ${rusDateOnly(date)}`;
export const rusTimeDateLikeAPlus = (date, withSeconds = false) => `${rusTimeOnly(date, withSeconds)} (${rusDateOnly(date)})`;
export const rusTimeDateBr = (date, withSeconds = false) => `${rusTimeOnly(date, withSeconds)}<br/>${rusDateOnly(date)}`;
export const rusDateNoYear = (date) => `${pad0(date.getDate(), 2)}.${pad0(date.getMonth() + 1, 2)}`;
export function parseRusDate(str) {
    const re = /^(\d\d?).(\d\d?).((?:1\d|20\d\d))$/;
    const m = re.exec(str);
    if (m == null)
        return null;
    const day = parseInt(m[1], 10);
    const month = parseInt(m[2], 10);
    const year = parseInt(m[3], 10);
    if (day < 0 || day > 31)
        return null;
    if (month < 1 || month > 12)
        return null;
    return new Date(year < 100 ? 2000 + year : year, month - 1, day);
}
export function parseRusTime(str) {
    const time_example = /^(\d\d?):(\d\d?)/;
    const validate_time = time_example.exec(str);
    if (!validate_time)
        return null;
    const hour = parseInt(validate_time[1], 10);
    const minut = parseInt(validate_time[2], 10);
    if (hour < 0 || hour > 23)
        return null;
    if (minut < 0 || minut > 59)
        return null;
    return { hour, minut };
}
export const isSameDay = (date1, date2) => date1.getFullYear() == date2.getFullYear() &&
    date1.getMonth() == date2.getMonth() &&
    date1.getDate() == date2.getDate();
export function currentServerUnixTime(server_time, now = new Date()) {
    const { local, server } = server_time;
    return any2unixtime(now) - local + server;
}
export const getDeviceTime = (timezone) => {
    const now = new Date().valueOf();
    const timezoneOffset = new Date().getTimezoneOffset() / 60;
    const time = new Date((now / 1e3 + (timezone + timezoneOffset) * 60 * 60) * 1e3);
    return rusTimeOnly(time);
};
export function secondsToDelay(s) {
    return new Promise((resolve) => setTimeout(resolve, s * 1e3));
}
